module.exports = __webpack_public_path__ + "img/re_event2_mo.5c0551e1.png";